import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import { getDroneSpecs } from './helpers/getDroneSpecs';
import type { FunctionComponent, Props, Spec } from './types';

import styles from './styles.module.scss';

const renderSpecBody = (spec: Spec) => (
    <>
        <Wrapper className={styles.specLabel}>{spec.label}</Wrapper>

        <Wrapper className={styles.specValue}>{spec.value}</Wrapper>
    </>
);

const DroneCardDetails: FunctionComponent<Props> = ({
    className = '',
    drone,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const specs = getDroneSpecs({
        drone,
        labels: {
            dronePrefix: t.DRONE_PREFIX,
            emDash: t.EM_DASH,
            faaPrefix: t.FAA_PREFIX,
            firmwareVersion: t.FIRMWARE_VERSION,
            ids: t.IDS,
            unitAcres: t.UNIT_ACRES,
            unitDays: t.UNIT_DAYS,
            unitFlights: t.UNIT_FLIGHTS_LOWER,
            unitHoursShort: t.UNIT_HOURS_SHORT,
            usage: t.USAGE,
            warranty: t.WARRANTY,
            warrantyExpPrefix: t.WARRANTY_EXP_PREFIX,
            warrantyExpired: t.WARRANTY_EXPIRED
        },
        now: new Date()
    });

    return (
        <VerticalContainer className={`${styles.specs} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.specStrip}>
                {renderSpecBody(specs.usage)}
            </HorizontalContainer>

            <HorizontalContainer className={styles.specStrip}>
                {renderSpecBody(specs.warranty)}
            </HorizontalContainer>

            <HorizontalContainer className={styles.specStrip}>
                {renderSpecBody(specs.ids)}
            </HorizontalContainer>

            <HorizontalContainer className={styles.specStrip}>
                {renderSpecBody(specs.firmware)}
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default DroneCardDetails;
